export const INCIDENT_TYPE = "incidentTypeId";
export const INCIDENT_CATEGORY = "incidentCategoryId";
export const PROPERTY_SPECIFIC = "propertySpecific";
export const COMMON_AREA = "commonFlag";
export const COMMON_AREA_FLAG = "commonAreaFlag";
export const ASSIGN_TO = "assignToId";
export const RESPONSIBLE = "responsible";
export const REPORTEE = "reporteeId";
export const ASSIGNMENT_DATE = "assignmentDate";
export const PRIORITY = "priority";
export const STATUS = "status";
export const ATTACHMENTS = "attachmentFile";
export const DESCRIPTION = "description";
export const PROPERTY_ID = "propertyId";
export const COMMENTS = "comment";

export const priorityOptions = [
  { label: "Low", value: "LOW" },
  { label: "Medium", value: "MEDIUM" },
  { label: "High", value: "HIGH" },
  { label: "Urgent", value: "URGENT" },
  { label: "Emergency", value: "EMERGENCY" },
];
